exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-text-align[data-v-91614ff8]{text-align:right!important}@media (max-width:767px){.custom-text-align[data-v-91614ff8]{text-align:left!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-91614ff8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/form-components/input-date-navigation.vue
// module id = 1539
// module chunks = 0